// @vendors
const React = require('react');
// @utilities
const { FormattedText } = require('core/i18n').i18n;
require('./ChatError.scss');

const ChatError = () => {
    return (
        <div className="chat-error">
            <div className="chat-error__icon">
                <i className="icon-error" />
            </div>
            <div className="chat-error__text">
                <h4 className="chat-error__title">
                    <FormattedText value="chatError-noChatTitle" />
                </h4>
                <p>
                    <FormattedText
                        className="chat-error__text-error"
                        value="chatError-noChatText1"
                    />
                </p>
                <p>
                    <FormattedText
                        className="chat-error__text-help"
                        value="chatError-noChatText2"
                    />
                </p>
            </div>
        </div>
    );
};

module.exports = ChatError;

